var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useWorkflowStepStore } from "@/stores/workflowStepStore";
export function fromSimple(data, appendData = false, defaultPosition = { top: 0, left: 0 }) {
    return __awaiter(this, void 0, void 0, function* () {
        const stepStore = useWorkflowStepStore();
        const stepIdOffset = stepStore.getStepIndex + 1;
        Object.values(data.steps).forEach((step) => {
            // If workflow being copied into another, wipe UUID and let
            // Galaxy assign new ones.
            if (appendData) {
                delete step.uuid;
                if (!step.position) {
                    // Should only happen for manually authored editor content,
                    // good enough for a first pass IMO.
                    step.position = { top: step.id * 100, left: step.id * 100 };
                }
                step.id += stepIdOffset;
                step.position.left += defaultPosition.left;
                step.position.top += defaultPosition.top;
                Object.values(step.input_connections).forEach((link) => {
                    if (link === undefined) {
                        console.error("input connections invalid", step.input_connections);
                    }
                    else {
                        let linkArray;
                        if (!Array.isArray(link)) {
                            linkArray = [link];
                        }
                        else {
                            linkArray = link;
                        }
                        linkArray.forEach((link) => {
                            link.id += stepIdOffset;
                        });
                    }
                });
            }
        });
        Object.values(data.steps).map((step) => {
            stepStore.addStep(step);
        });
    });
}
export function toSimple(workflow) {
    const steps = workflow.steps;
    const report = workflow.report;
    const license = workflow.license;
    const creator = workflow.creator;
    const annotation = workflow.annotation;
    const name = workflow.name;
    return { steps, report, license, creator, annotation, name };
}
